import api from '@/api';

const resource = 'atena/tela';

export default {
  getListaTelas(data) {
    return api.get(`${resource}`, {
      params: data,
    });
  },
  getTela(id) {
    return api.get(`${resource}/${id}`);
  },
  postTela(data) {
    return api.post(`${resource}`, data);
  },
  putTela(data) {
    return api.put(`${resource}/${data.identificadortela}`, data);
  },
  deleteTela(id) {
    return api.delete(`${resource}/${id}`);
  },
  getTelaPermissoesPerfil(id, data) {
    return api.get(`${resource}/${id}/permissoes-perfil`, {
      params: data,
    });
  },
  postTelaPermissoesPerfil(id, data) {
    return api.post(`${resource}/${id}/permissoes-perfil`, data);
  },
};